import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    RegionSecondLevel,
} from 'app/enums/label.enums'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/RateCard/RateCard.requests'
import {
    RegionalServiceAvailabilityItem,
} from './RegionalServiceAvailability.types'

const availabilityCellMapper = (propertyName: string) => {
    return (item: RegionalServiceAvailabilityItem) => {
        return {
            children: item[propertyName] ? 'Available' : 'Not Available',
        }
    }
}

const config: SkyNetTableTab<keyof RegionalServiceAvailabilityItem> = {
    name: 'Regional Service Availability',
    url: RateCardsTabs.RegionalServiceAvailability,
    customUrl: requests.regionalServiceAvailabilityFilterRequest().url,
    fields: [
        {
            name: 'regionSecondLevel',
            labelKey: 'Country.regionSecondLevel',
            componentName: 'EnumValue',
            allowedValuesEnum: RegionSecondLevel,
        },
        {
            name: 'originAirlineLeaseRequired',
            labelKey: 'RegionalServiceAvailabilityRateCard.originAirlineLeaseRequired',
            componentName: 'Boolean',
        },
        {
            name: 'originPickupStationAvailableCol',
            labelKey: 'RegionalServiceAvailabilityRateCard.originPickupStationAvailableCOL',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('originPickupStationAvailableCol'),
        },
        {
            name: 'originPickupStationAvailableCrt',
            labelKey: 'RegionalServiceAvailabilityRateCard.originPickupStationAvailableCRT',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('originPickupStationAvailableCrt'),
        },
        {
            name: 'originTruckPositioning',
            labelKey: 'RegionalServiceAvailabilityRateCard.originTruckPositioning',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('originTruckPositioning'),
            sorting: false,
        },
        {
            name: 'originPositioningLtl',
            labelKey: 'RegionalServiceAvailabilityRateCard.originPositioningLTL',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('originPositioningLtl'),
            sorting: false,
        },
        {
            name: 'originPositioningFtl',
            labelKey: 'RegionalServiceAvailabilityRateCard.originPositioningFTL',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('originPositioningFtl'),
            sorting: false,
        },
        {
            name: 'originTruckCapacity',
            labelKey: 'RegionalServiceAvailabilityRateCard.originTruckCapacity',
            mapCellProps: ({
                originTruckCapacity,
                originTruckCapacityAvailability,
            }: RegionalServiceAvailabilityItem) => {
                return {
                    children: originTruckCapacityAvailability ? originTruckCapacity : 'Not Available',
                }
            },
        },
        {
            name: 'destinationAirlineLeaseRoundtripRequired',
            labelKey: 'RegionalServiceAvailabilityRateCard.destinationAirlineLeaseRoundtripRequired',
            componentName: 'Boolean',
        },
        {
            name: 'destinationDropoff',
            labelKey: 'RegionalServiceAvailabilityRateCard.destinationDropoff',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('destinationDropoff'),
            sorting: false,
        },
        {
            name: 'destinationCollectionLtl',
            labelKey: 'RegionalServiceAvailabilityRateCard.destinationCollectionLTL',
            componentName: 'Boolean',
            mapCellProps: availabilityCellMapper('destinationCollectionLtl'),
            sorting: false,
        },

    ],
}

export default config
